const lastRowSelector = '> .grid-container > .grid-column > .row:last-child, > .grid-container > .grid-column > .row:last-of-type, > .grid-container > .grid-column > .row:only-child, > .grid-container > .grid-column > .row:only-of-type';

export default function grid() {
  return {
    _id: false,
    type: 'puddle.grid',
    pageCSS: '',
    bounceDroplet: false,
    lastRowSelector,
    gridColumns: 3,
    autoFit: {
      desktop: false,
      tablet: false,
      mobile: false,
    },
    rows: [],
    mediaQueries: [
      {
        selector: lastRowSelector,
        properties: [
          {
            property: 'margin-bottom',
            desktop: '0px',
            tablet: 'default',
            mobile: 'default',
          },
        ],
      },
      {
        selector: '> .grid-container',
        properties: [
          {
            property: 'grid-template-columns',
            desktop: 'repeat(3, 1fr)',
            tablet: 'default',
            mobile: 'default',
          },
        ],
      },
    ],
    isShared: false,
    templateRegion: false,
  };
}



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/grid/droplet.schema.js